<template lang="html">
  <div class="home-container" @change-alert="onChangeAlert">
      <div class="sidebar-container">
          <v-sidebar></v-sidebar>
      </div>
      <div class="right-container">
          <div class="header-container">
              <v-head :alertNum="alertValue"></v-head>
          </div>
          <div class="content-container">
              <router-view></router-view>
          </div>
      </div>

  </div>
</template>

<script>
import vHead from './Header.vue';
import vSidebar from './Sidebar.vue';
export default {
    data() {
        return {
            role: '',
            alertValue: null,
        }
    },
    mounted() {
        this.setMapScript();
        this.getRole();
    },
    methods: {
        setMapScript(){
            if (sessionStorage.getItem('acceptLanguage') == 'en-US, en') {
              this.setGoogleMapScript()
            }else{
              this.setQQMapScript()
            }
        },

        setGoogleMapScript(){
          let googleMapSrc = "https://maps.googleapis.com/maps/api/js?key=AIzaSyBsQtBb98MIAQkgPVW5B22u2NYf_TKf5Kg",
            isSetGoogleMap = 1;

          let scripts = document.getElementsByTagName('script');
          for (let i=0,j=scripts.length; i<j; i++){
            let src = scripts[i].src;
            if (src == googleMapSrc){
              isSetGoogleMap = 0;
              continue;
            }
          }

          if (isSetGoogleMap == 1){
            let script = document.createElement('script');
            script.src = googleMapSrc;
            document.getElementsByTagName('head')[0].appendChild(script);
          }
        },

        setQQMapScript(){
          let qqMapSrc = "https://map.qq.com/api/js?v=2.exp&key=YY6BZ-TRDCV-FCOPH-U4EUA-7VUU5-NEFSU",
            isSetQQMap = 1;

          let scripts = document.getElementsByTagName('script');
          for (let i=0,j=scripts.length; i<j; i++){
            let src = scripts[i].src;
            if (src == qqMapSrc){
              isSetQQMap = 0;
              continue;
            }
          }

          if (isSetQQMap == 1){
            let script1 = document.createElement('script');
            script1.src = qqMapSrc;
            document.getElementsByTagName('head')[0].appendChild(script1);

            let script2 = document.createElement('script')
            script2.src = 'https://mapapi.qq.com/jsapi_v2/2/4/138/main.js'
            document.getElementsByTagName('head')[0].appendChild(script2);
          }
        },

        onChangeAlert(alertValue) {
            this.alertValue = alertValue;
        },
        getRole() {
            // 0: super account => all
            // 1: systerm administrator => appManagement&appDownload&terminalManagement
            // 2: app administrator => appManagement&appDownload
            // 3: terminal administrator => terminalManagement

            this.role = sessionStorage.getItem('verifoneRoleId');

            // this.$router.replace('/dashboard');

            // if(this.role == 0) {
            //     this.$router.replace('/dashboard');
            // }else if(this.role == 1 || this.role == 2) {
            //     this.$router.replace('/appManagement');
            // }else if(this.role == 3) {
            //     this.$router.replace('/terminalList');
            // }
        }
    },
	components: {
		vHead, vSidebar
	}
}
</script>

<style>
* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    /* font-family: 'Microsoft YaHei,Arial'; */
    font-family: 'Arial';
    word-break: break-word;
}
.flex-row{
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
}
.flex-col {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
.home-container {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
}
.right-container {
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    /* background-color: #E0EAF4; */
    width: 100%;
    overflow: auto;
    background: #f0f3f5;
}
.home-container>div, .home-container {
    height: 100vh;
}
.sidebar-container {
    background-color: #3a73d9;
}
.breadCrumb-container {
	font-size: 18px;
	font-family: 'Arial';
	padding: 20px 30px;
    background-color: #fff;
    border-bottom: 1px solid rgba(170, 170, 170, 1);
    position: fixed;
    z-index: 4;
    top: 0;
    left: 220px;
    width: 100%;
}
.el-breadcrumb {
    height: 25px;
    line-height: 25px;
}
.el-breadcrumb__inner {
    color: #707071!important;
    font-size: 20px;
    font-weight: 400;
}
.title-container {
  line-height: 41px;
  color: rgba(16, 16, 16, 1);
  font-size: 28px;
  text-align: left;
  font-family: Roboto;
  padding:5px 30px 10px 25px;
}
.second-tip {
  width:100%;
  padding:10px 0px;
  justify-content: space-between;
}
.title {
  color: rgba(16, 16, 16, 1);
  text-align: left;
  font-family: Roboto;
  /* padding-left: 20px; */
}
.tipImg {
  width: 60px;
  height: 60px;
}
.tip-content {
  text-align: center;
}
.tipTxt {
  margin-top: 25px;
  font-size: 16px;
}
.content-container {
    padding: 80px 50px 20px 50px;
}
.verifone-btn {
    width: 85px;
    height: 40px;
    padding: 0;
}
.verifone-btn.is-plain {
    background: #fff;
}
.btn-table .el-table td, .btn-table .el-table t {
    padding: 6px 0!important;
}
.verifone-panel {
	padding: 15px 0;
	background-color: #fff;
	border-radius: 20px;
	box-shadow: 1px 1px 1px 1px rgba(129, 153, 136, 0.75);
	-webkit-box-shadow: 1px 1px 1px 1px rgba(129, 153, 136, 0.75);
}
.select-input-container {
  position: relative;
  border: 1px solid #dcdfe6;
  margin-right: 10px;
}
.rearchSelect {
  position: absolute;
  width: 100px;
  left: 0px;
  top:0;

}
.rearchSelect input {
  border:none!important;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
.reachInput {
  width: 400px;
  position: absolute;
  padding-left:100px;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  left: 0px;
  top:0;
}
.merchant-container .reachInput input, .terminal-list .reachInput input {
  border:none!important;
}
.reachInput {
  position: relative;
  border-right:none!important;
}
.el-dialog {
    border-radius: 20px;
}
.el-dialog__footer {
    text-align: center;
}
.warn-icon {
    width: 25px;
    height: 25px;
}
.warn-dialog .el-dialog__body {
    padding: 0 20px 30px 20px;
}
.warn-container {
    align-items: center;
}
.dialog-body {
    padding: 40px 40px 10px 40px;
}
.submit-container {
	padding-right: 50px;
	display: flex;
	display: -webkit-flex;
	justify-content: flex-end;
}
.search-btn {
    margin-right: 30px;
    padding: 12px 14px;
}
.is-disabled {
    color: #fff!important;
    background-color: #ddd!important;
    border: none!important;
}
.verifone-tabs{
    padding-top: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Home.vue